import { render, staticRenderFns } from "./StockOrderBasket.vue?vue&type=template&id=72cf52ac"
import script from "./StockOrderBasket.vue?vue&type=script&lang=js"
export * from "./StockOrderBasket.vue?vue&type=script&lang=js"
import style0 from "./StockOrderBasket.vue?vue&type=style&index=0&id=72cf52ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports